// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__q-ulu","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3ciAu"};